/*
**************************** 
홈페이지 FAQ
*****************************
*/

import React from "react";

export default function Faq(props) {

    return (
        <div>
            <div className="mt-5 pt-2">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item small"><a href="#">고객센터</a></li>
                    <li className="breadcrumb-item active small">FAQ</li>
                </ol>
            </div>

            <ul className="nav nav-tabs d-flex justify-content-center" role="tablist">
                <li className="nav-item medium" role="presentation">
                    <a className="nav-link active text-black text-decoration-none" data-bs-toggle="tab" href="#toktokbox" aria-selected="true" role="tab" tabIndex="-1">톡톡박스</a>
                </li>
                <li className="nav-item medium" role="presentation">
                    <a className="nav-link text-black text-decoration-none" data-bs-toggle="tab" href="#contents" aria-selected="false" role="tab" tabIndex="-1">콘텐츠</a>
                </li>
            </ul>
            <div className="container">
                <div id="myTabContent" className="tab-content">
                    <div className="tab-pane  active show" id="toktokbox" role="tabpanel">
                        <div className="mt-5">
                            <div className="text-start">
                                <a className="btn btn-outline-primary" data-bs-toggle="collapse" aria-expanded="false" aria-controls="collapseExample">
                                    Q 톡톡박스를 사용할 수 있는 연령은 어떻게 되나요?
                                </a>
                            </div>
                            <div className=" mt-2 text-start" id="qb1">
                                <div className="card card-body ">
                                    A 톡톡박스는 4세부터 이용 가능하고 제휴 콘텐츠를 포함하여 4세부터 온 가족이 다양하게 사용할 수 있습니다.
                                </div>
                            </div>
                        </div>
                        <div className="mt-5">
                            <div className="text-start">
                                <a className="btn btn-outline-primary" data-bs-toggle="collapse" aria-expanded="false" aria-controls="collapseExample">
                                    Q 아이들이 사용하기에 안전한가요?
                                </a>
                            </div>
                            <div className=" mt-2 text-start" id="qb3">
                                <div className="card card-body">
                                    A 바퀴를 고정할
                                    수 있고, 밀어도 쉽게
                                    넘어지지 않도록 설계되었습니다. 또한
                                    디스플레이 강화유리가 부착되어 생활
                                    스크래치와 충격으로부터 안전합니다.(다만,
                                    너무
                                    큰 충격을 주시면 안돼요!)
                                </div>
                            </div>
                        </div>
                        <div className="mt-5">
                            <div className="text-start">
                                <a className="btn btn-outline-primary" data-bs-toggle="collapse" aria-expanded="false" aria-controls="collapseExample">
                                    Q A/S도 가능한가요?
                                </a>
                            </div>
                            <div className=" mt-2 text-start" id="qb4">
                                <div className="card card-body">
                                    A
                                    네, 물론 가능합니다. 절차에 따라 신청
                                    후 A/S
                                    받으실
                                    수 있습니다.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="contents" role="tabpanel">
                        <div className="mt-5">
                            <div className="text-start">
                                <a className="btn btn-outline-primary" data-bs-toggle="collapse" aria-expanded="false" aria-controls="collapseExample">
                                    Q 톡톡박스 콘텐츠가 궁금해요.
                                </a>
                            </div>
                            <div className=" mt-2 text-start" id="qb1">
                                <div className="card card-body ">
                                    A 톡톡박스 내에는 자체 개발한 톡톡콘텐츠와
                                    제휴사 콘텐츠가 있습니다. 톡톡박스를 구매하면
                                    톡톡콘텐츠는 처음 12개월 동안은 무료로
                                    이용하고
                                    그 이후에는 구독하여 이용할
                                    수
                                    있습니다. 제휴사 콘텐츠는 원하는 패키지를
                                    구매하여 12개월 동안 이용하고
                                    그 이후에는
                                    아이의 관심과 흥미에 따라 필요한 콘텐츠만
                                    구독하여 이용할
                                    수 있습니다.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}